import styled from 'styled-components';
import { colors } from "../../../../utils/colors";

export const NoOrdersWrapper = styled.div`
    max-width: 90%;
    max-width: 300px;
    margin: 50px auto;
    border-radius: 15px;
    border: 3px solid ${colors.CREAM};
    padding: 25px;
    text-align: center;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

export const OrderListWrapper = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 50px auto;
`;